module.exports = __webpack_public_path__ + "img/shuilian2.ec53a37b.png";